/**
 * The below ApplicationData types are an attempt to give structure
 * to the JSON data that is saved in the DB. It's by
 * no means exhaustive and you may find discrepencies. The next step
 * to ensuring correct data is validating the data with a library
 * like Zod or Joi.
 *
 * These are also duplicated in the services repo
 *
 */
// List of valid application versions
export var APPLICATION_VERSION;
(function (APPLICATION_VERSION) {
    APPLICATION_VERSION["V1"] = "1";
    APPLICATION_VERSION["V2"] = "2";
    APPLICATION_VERSION["V3"] = "3";
})(APPLICATION_VERSION || (APPLICATION_VERSION = {}));
/** This application status represents the onboarding client application status */
export var APPLICATION_STATUS;
(function (APPLICATION_STATUS) {
    APPLICATION_STATUS["IN_PROGRESS"] = "IN_PROGRESS";
    APPLICATION_STATUS["PENDING_LETTER_OF_EMPLOYMENT"] = "PENDING_LETTER_OF_EMPLOYMENT";
    APPLICATION_STATUS["APPROVED"] = "APPROVED";
    APPLICATION_STATUS["SUBMITTED"] = "SUBMITTED";
    APPLICATION_STATUS["CANCELLED"] = "CANCELLED";
    APPLICATION_STATUS["DECLINED"] = "DECLINED";
    APPLICATION_STATUS["OTHER"] = "OTHER";
    APPLICATION_STATUS["COMPLETED"] = "COMPLETED";
})(APPLICATION_STATUS || (APPLICATION_STATUS = {}));
export var EMPLOYMENT_STATUS;
(function (EMPLOYMENT_STATUS) {
    EMPLOYMENT_STATUS["FULL_TIME"] = "FULL_TIME";
    EMPLOYMENT_STATUS["FULL_TIME_PROBATIONARY"] = "FULL_TIME_PROBATIONARY";
    EMPLOYMENT_STATUS["PART_TIME"] = "PART_TIME";
    EMPLOYMENT_STATUS["SELF_EMPLOYED"] = "SELF_EMPLOYED";
    EMPLOYMENT_STATUS["CONTRACT"] = "CONTRACT";
    EMPLOYMENT_STATUS["UNEMPLOYED"] = "UNEMPLOYED";
})(EMPLOYMENT_STATUS || (EMPLOYMENT_STATUS = {}));
export var MARITAL_STATUS;
(function (MARITAL_STATUS) {
    MARITAL_STATUS["MARRIED"] = "MARRIED";
    MARITAL_STATUS["WIDOWED"] = "WIDOWED";
    MARITAL_STATUS["SEPARATED"] = "SEPARATED";
    MARITAL_STATUS["DIVORCED"] = "DIVORCED";
    MARITAL_STATUS["SINGLE"] = "SINGLE";
    MARITAL_STATUS["COMMON_LAW"] = "COMMON_LAW";
})(MARITAL_STATUS || (MARITAL_STATUS = {}));
export var RESIDENCY_STATUS;
(function (RESIDENCY_STATUS) {
    RESIDENCY_STATUS["CITIZEN"] = "CITIZEN";
    RESIDENCY_STATUS["PERMANENT_RESIDENT"] = "PERMANENT_RESIDENT";
    RESIDENCY_STATUS["OTHER"] = "OTHER";
})(RESIDENCY_STATUS || (RESIDENCY_STATUS = {}));
// Should probably be in a constants file but these should be in close proximity to one gets updated when the other does
export var LATEST_APPLICATION_VERSION = APPLICATION_VERSION.V3;
export var SUPPORTED_VERSIONS = [LATEST_APPLICATION_VERSION];
//# sourceMappingURL=index.js.map